import { Pipe, PipeTransform } from '@angular/core';
import { SelectedCell } from '../common/selected-cell';

@Pipe({
  name: 'checkIfCellSelected'
  /* pure: false */
})
export class CheckIfCellSelectedPipe implements PipeTransform {

/*   transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  } */

  transform(selectedCellsData: SelectedCell[], colName, index): number {
    console.count('Pipe checkIfCellSelected: ' + colName + index );
    console.log(selectedCellsData);
    const found = selectedCellsData.findIndex(cell => cell.colName === colName && cell.rowIndex === index);

/*     if (this.startSelectionParams && this.startSelectionParams.colName === colName && this.startSelectionParams.rowIndex === index) {
      return 0;
    } */

    return found;
  }

/*   checkIfCellSelected(colName, index) {
    // console.count(colName + index);
    const found = this.selectedCellsData.findIndex(cell => cell.colName === colName && cell.rowIndex === index);

    if (this.startSelectionParams && this.startSelectionParams.colName === colName && this.startSelectionParams.rowIndex === index) {
      return 0;
    }

    return found;
  } */

}
